import { render } from "./AccountEditPage.vue?vue&type=template&id=5a70466a&ts=true"
import script from "./AccountEditPage.vue?vue&type=script&lang=ts"
export * from "./AccountEditPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__